module.exports = __webpack_public_path__ + "img/ArrowButton.10ed4657.svg";